@if (teaserBetState && pick) {
    <div class="betslip-digital-bet-pick-column-0">
        @let isLinear = isLinear$ | async;
        <bs-digital-pick-selection [pick]="pick" [selection]="teaserPickState" [betslipType]="betslipType" [isLinear]="isLinear ?? false" />
        <bs-digital-combo-prevention-indicator [pick]="pick" [betslipType]="betslipType" />
    </div>
    <div class="betslip-digital-bet-pick-column-1 {{ pickClass }}" (click)="eventClick()">
        <div class="betslip-digital-pick__line-0">
            <span>{{ optionName }}</span>
        </div>
        <div class="betslip-digital-pick__line-1">{{ pick.marketName.name }}</div>
        <div class="betslip-digital-pick__line-2">
            <ng-container *msShowInEpcot="{ showInEpcot: true }">
                @if (pick.isVirtual) {
                    <span class="betslip-digital-pick__virtual-badge icon" [class]="'sports-' + pick.sportId"></span>
                }
            </ng-container>
            <ng-container *msShowInEpcot="{ showInEpcot: false }">
                @if (pick.isVirtual) {
                    <span class="betslip-digital-pick__virtual-badge theme-virtualsport"></span>
                }
            </ng-container>
            @if (pick.isLive) {
                <span class="betslip-digital-pick__live-badge">{{ messages.common.Live }}</span>
            }
            {{ pick.eventName.name }}
        </div>
        <div class="betslip-digital-pick__teaser-points">
            <span class="teased-point">+{{ teaserPointsInfo?.teasedPoints }}</span>
            <bs-digital-pick-odds [pick$]="pickChange$" [teasedValue]="teaserPointsInfo.newPoints" [oddsDisplayFormat]="oddsDisplayFormat" />
        </div>
    </div>
    @if (!(isLinear$ | async)) {
        <div class="betslip-digital-bet-pick-column-2">
            <bs-digital-pick-remove-button (remove)="removePick()" />
        </div>
        <bs-tabbed-pick-errors [pickId]="pick.id" [betslipType]="betslipType" />
    }
}
